"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Search = _ref => {
  let {
    title = 'Search',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.688 21.344q2.5 0 4.25-1.75t1.75-4.25-1.75-4.25-4.25-1.75-4.25 1.75-1.75 4.25 1.75 4.25 4.25 1.75zM20.688 21.344l6.625 6.625-2 2-6.625-6.625v-1.063l-0.375-0.375q-2.375 2.063-5.625 2.063-3.625 0-6.156-2.5t-2.531-6.125 2.531-6.156 6.156-2.531 6.125 2.531 2.5 6.156q0 3.25-2.063 5.625l0.375 0.375h1.063z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Search);
Search.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Search",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Search'",
        "computed": false
      },
      "required": false
    }
  }
};